import { newEmailType } from "../../components/Pages/Diary/SelectedBooking/Messages/Email/SendEmailController";
import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";

export const previewEmail = async (
  bookingId: string,
  email: newEmailType
): Promise<string> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const headerParams = {
    source: "admin"
  };

  const preDefinedSelectedAttachments: any =
    email.preDefinedSelectedAttachments;
  const attachments = email.attachments
    .map((a) => ({
      name: a.filename,
      path: a.path
    }))
    .concat(preDefinedSelectedAttachments);

  const data = {
    bookingId: `${bookingId}`,
    app_name: "com.collins.mobile",
    ...email,
    to: email.to?.[0].address,
    attachments,
    preDefinedSelectedAttachments: undefined,
    ...headerParams
  };

  const url = `${environmentVars?.COLLINS_API_BASE_URL}/booking-emails/${bookingId}/${email.type}/preview`;

  return await fetch(url, {
    cache: "no-cache",
    method: "POST",
    headers: {
      Accept: "application/json",
      ["Content-type"]: "application/json",
      Authorization: `Bearer ${token}`,
      ...headerParams
    },
    body: JSON.stringify(data)
  })
    .then(async (response) => {
      try {
        return (await response?.clone()?.json())?.message;
      } catch {
        return await response?.text();
      }
    })
    .catch((error) => {
      console.warn(error);
      return "An unknown error occurred, please try again.";
    });
};
